import * as tslib_1 from "tslib";
import React, { useContext } from 'react';
import MobileCollectionPopup from './MobileCollectionPopup';
import DesktopCollectionPanel from './DesktopCollectionPanel';
import { MobileContext } from '../Context';
import { getDeviationNotificationQueue } from '../DeviationPage/redux/helpers';
export var CollectionPanel = function (props) {
    var isMobile = useContext(MobileContext);
    if (isMobile) {
        return React.createElement(MobileCollectionPopup, tslib_1.__assign({}, props));
    }
    return (React.createElement(DesktopCollectionPanel, tslib_1.__assign({ notificationQueue: getDeviationNotificationQueue(props.collectibleDeviation) }, props)));
};
export default CollectionPanel;
//# sourceMappingURL=CollectionPanel.js.map